var app = angular.module('leonardo');

var CacheService = function($q) {
  var service = {};
  var CACHE_PREFIX = 'leo_cache_';
  var DEFAULT_EXPIRATION = 30 * 60 * 1000; 

  service.get = function (key) {
    try {
        var cacheKey = CACHE_PREFIX + key;
        var cachedItem = sessionStorage.getItem(cacheKey);
        
        if (!cachedItem) return null;
        
        var parsedItem = JSON.parse(cachedItem);
        // Check if cache is expired
        if (Date.now() - parsedItem.timestamp > parsedItem.expiration) {
          // Cache expired, remove it
          sessionStorage.removeItem(cacheKey);
          return null;
        }
        return parsedItem.data;
    }
    catch (e) {
      return null;
    }
  };

  service.set = function(key, data, expiration) {
    try {
      var cacheKey = CACHE_PREFIX + key;
      var cacheObject = {
        data: data,
        timestamp: Date.now(),
        expiration: expiration || DEFAULT_EXPIRATION
      };
      
      sessionStorage.setItem(cacheKey, JSON.stringify(cacheObject));
    } catch (e) {
      console.error('Error saving to cache:', e);
    }
  };

  service.clearAll = function() {
    try {
      Object.keys(sessionStorage).forEach(function(key) {
        if (key.startsWith(CACHE_PREFIX)) {
          sessionStorage.removeItem(key);
        }
      });
    }
    catch (e) {
      console.error('Error clearing cache:', e);
    }
  };

  service.remove = function(key) {
    try {
      var cacheKey = CACHE_PREFIX + key;
      sessionStorage.removeItem(cacheKey);
    } catch (e) {
      console.error('Error removing from cache:', e);
    }
  };

  service.getOrFetch = function(key, promiseFn, expiration) {
    var cachedData = service.get(key);
    
    if (cachedData !== null) {
      return $q.resolve(cachedData);
    }
    
    let isAdmin = service.get('user')?.is_staff;
    return promiseFn().then(function(data) {
      if(!isAdmin) {
        service.set(key, data, expiration);
      }
      return data;
    });
  };

  return service;
};

app.factory('CacheService', ['$q', CacheService]);